import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';

interface Candidate {
  id: string;
  name: string;
  cv_path?: string;
  parsed_fields?: {
    status?: string;
    message?: string;
  };
}

interface CandidatesData {
  items?: Candidate[];
}

export const useProcessingNotifications = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const interval = setInterval(() => {
      // Get current candidates data
      const candidatesData = queryClient.getQueryData<CandidatesData>(['candidates']);
      
      if (candidatesData?.items) {
        candidatesData.items.forEach(candidate => {
          if (candidate.cv_path && candidate.parsed_fields?.status === 'completed') {
            // Check if we should show a completion notification
            const lastStatus = localStorage.getItem(`candidate_${candidate.id}_last_status`);
            if (lastStatus !== 'completed') {
              toast.success(`CV processing completed for ${candidate.name}!`, {
                duration: 5000,
                icon: '✅',
              });
              localStorage.setItem(`candidate_${candidate.id}_last_status`, 'completed');
            }
          } else if (candidate.cv_path && candidate.parsed_fields?.status === 'failed') {
            // Check if we should show a failure notification
            const lastStatus = localStorage.getItem(`candidate_${candidate.id}_last_status`);
            if (lastStatus !== 'failed') {
              toast.error(`CV processing failed for ${candidate.name}. Please try again.`, {
                duration: 8000,
                icon: '❌',
              });
              localStorage.setItem(`candidate_${candidate.id}_last_status`, 'failed');
            }
          }
        });
      }
    }, 5000); // Check every 5 seconds

    return () => clearInterval(interval);
  }, [queryClient]);
};
